// import { Plus } from "lucide-react";

// const ColorInput = ({ value, placeholder, onClick }) => {
//   return (
//     <button
//       type="button"
//       onClick={onClick}
//       className="flex h-11 w-full items-center justify-between rounded-md border border-[#14708A] bg-[#151515] px-4 text-sm text-neutral-100 outline-none"
//     >
//       <span className={value ? "text-neutral-100" : "text-neutral-100/50"}>
//         {value || placeholder}
//       </span>

//       <span className="flex items-center gap-2">
//         <span
//           className="h-5 w-5 rounded-full border border-white/40"
//           style={{ backgroundColor: value }}
//         />
//         <Plus className="h-5 w-5 rounded-full border border-brand-15 text-brand-15" />
//       </span>
//     </button>
//   );
// };

// export default ColorInput;
import { Plus } from "lucide-react";

const ColorInput = ({ value, placeholder, onClick, onChange }) => {
  return (
    <div
      // type="button"
      onClick={onClick}
      className="flex h-11 w-full items-center justify-between rounded-md border border-[#14708A] bg-[#151515] px-4 text-sm text-neutral-100 outline-none"
    >
      <span className="flex items-center gap-2">
        <span
          className="h-5 w-5 rounded-full border border-white/40"
          style={{ backgroundColor: value || "#ffffff" }}
        />

        {/* <span className={value ? "text-neutral-100" : "text-neutral-100/50"}>
          {value || placeholder}
        </span> */}
        <input
          value={value || ""}
          placeholder={placeholder}
          onChange={(e) => onChange?.(e.target.value)}
          onClick={(e) => e.stopPropagation()}
          className="bg-transparent text-sm text-neutral-100 outline-none placeholder:text-neutral-100/50"
        />
      </span>
      {/* <span className="flex items-center gap-2"> */}
      <span className="flex items-center gap-3">
        {/* <span
          className="h-5 w-5 rounded-full border border-white/40"
          style={{ backgroundColor: value }}
        /> */}

        <span className="flex cursor-pointer items-center">
          <Plus className="h-5 w-5 rounded-full border border-brand-15 text-brand-15" />
        </span>
      </span>
    </div>
  );
};

export default ColorInput;
